import { CommonModule } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { SortIcon as SortIconBase } from 'prime-ng-old/table';
import { PARENT_TABLE } from './table.injection-token';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = (a0, a1, a2) => ({
  "pi-sort-amount-up-alt": a0,
  "pi-sort-amount-down": a1,
  "pi-sort-alt": a2
});
function UiTableSortIcon_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getBadgeValue());
  }
}
// required because of the constructor needing reference to ui-table component
export let UiTableSortIcon = /*#__PURE__*/(() => {
  class UiTableSortIcon extends SortIconBase {
    constructor(dt, cd) {
      super(dt, cd);
      this.dt = dt;
    }
    static {
      this.ɵfac = function UiTableSortIcon_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTableSortIcon)(i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTableSortIcon,
        selectors: [["p-sortIcon"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 6,
        consts: [[1, "p-sortable-column-icon", "pi", "pi-fw", 3, "ngClass"], [1, "p-sortable-column-badge"]],
        template: function UiTableSortIcon_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "i", 0);
            i0.ɵɵconditionalCreate(1, UiTableSortIcon_Conditional_1_Template, 2, 1, "span", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0, ctx.sortOrder === 1, ctx.sortOrder === -1, ctx.sortOrder === 0));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isMultiSorted() ? 1 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass],
        encapsulation: 2
      });
    }
  }
  return UiTableSortIcon;
})();